// extracted by mini-css-extract-plugin
module.exports = {"label":"dockOverloadCommon_label__3J60b","labelDisabled":"dockOverloadCommon_labelDisabled__18kXM","formControlWrapper":"dockOverloadCommon_formControlWrapper__1c0Pq"};